import Image from "next/image";
import React from "react";
import { useAppContext } from "@/context/Context"; // Import useAppContext

function EportalExp() {
  const [isMobile, setIsMobile] = React.useState(false);
  const { isLightTheme } = useAppContext(); // Get theme state

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // --- Theme-dependent styles ---
  const containerBg = isLightTheme
    ? "#fff" // Light theme background
    : "var(--color-darker)"; // Dark theme background (using a CSS variable for consistency)

  const titleColor = isLightTheme
    ? "inherit" // Inherit from parent, usually dark text
    : "var(--color-white-off)"; // Light text for dark mode

  const accentColor = "#A259E0"; // This purple accent can remain constant or change if you wish
                                // For now, we'll keep it the same as it's an "accent"

  const featureDescriptionColor = isLightTheme
    ? 'inherit' // Inherit from parent (usually dark text on light bg)
    : 'var(--rbt-color-body)'; // Lighter text for dark mode descriptions

  return (
    <div
      style={{
        width: "100%",
        minHeight: "600px",
        marginTop: "80px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // horizontal centering
        justifyContent: "center", // vertical centering
        background: containerBg, // Apply dynamic background
        boxSizing: "border-box",
        padding: "0 10px",
      }}
    >
      hello , what is you dream job
      {/* Title */}
      <h1
        style={{
          fontWeight: "bold",
          marginBottom: 50,
          textAlign: "center",
          fontSize: "4rem",
          color: titleColor, // Apply dynamic title color
        }}
      >
        Experience the <span style={{ color: accentColor }}>E-Portal</span>{" "}
        Difference
      </h1>

      {/* Images and captions container */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "70px",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "center" : "flex-start",
          width: "100%",
          maxWidth: 850,
        }}
      >
        {/* First feature */}
        <div
          style={{
            textAlign: "center",
            width: 250,
            marginBottom: isMobile ? 30 : 0,
          }}
        >
          <Image
            src="/MainHome/left1.png"
            alt="Feature 1"
            width={250}
            height={250}
            style={{ width: "100%", height: "auto", marginBottom: 18 }}
          />
          <div 
            className="feature-description" 
            style={{ 
              fontSize: 18,
              color: featureDescriptionColor // Apply dynamic description color
            }}
          >
            Adaptive tools that shape education around each learner’s needs.
          </div>
        </div>

        {/* Second feature */}
        <div
          style={{
            textAlign: "center",
            width: 250,
            marginBottom: isMobile ? 30 : 0,
          }}
        >
          <Image
            src="/MainHome/middle1.png"
            alt="Feature 2"
            width={250}
            height={250}
            style={{ width: "100%", height: "auto", marginBottom: 18 }}
          />
          <div 
            className="feature-description" 
            style={{ 
              fontSize: 18,
              color: featureDescriptionColor // Apply dynamic description color
            }}
          >
            Tutorials, tests, and collaboration tools combined in a single
            platform.
          </div>
        </div>

        {/* Third feature */}
        <div style={{ textAlign: "center", width: 250 }}>
          <Image
            src="/MainHome/third1.png"
            alt="Feature 3"
            width={250}
            height={250}
            style={{ width: "100%", height: "auto", marginBottom: 10 }}
          />
          <div 
            className="feature-description" 
            style={{ 
              fontSize: 18,
              color: featureDescriptionColor // Apply dynamic description color
            }}
          >
            E-Portal keeps learners motivated with interactive tools and
            measurable progress.
          </div>
        </div>
      </div>
    </div>
  );
}

export default EportalExp;